var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ready)?_c('router-view'):_vm._e(),_c('loading',{attrs:{"active":!_vm.ready,"color":"#0061ad"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }